import { gql } from "@apollo/client";

const ADD_SCHEDULED_TRANSACTION = gql`
  mutation createRepeatingScheduledTransaction($schedule: ScheduledInput!, $templateTransaction: CombinedCreateTransactionInput!, $productId: ID!) {
    createRepeatingScheduledTransaction(schedule: $schedule, templateTransaction: $templateTransaction, productId: $productId) {
      createdAt
      endDate
      frequency
      numberOfOccurrences
      startDate
      templateTransaction
      updatedAt
    }
  }
`;

const UPDATE_SCHEDULE_TRANSACTION = gql`
  mutation updateRepeatingScheduledTransaction($schedule: ScheduledInput!, $templateTransaction: CombinedCreateTransactionInput!, $productId: ID!, $scheduleIndex: Int!) {
    createRepeatingScheduledTransaction(schedule: $schedule, templateTransaction: $templateTransaction, productId: $productId, scheduleIndex: $scheduleIndex) {
      createdAt
      endDate
      frequency
      numberOfOccurrences
      startDate
      templateTransaction
      updatedAt
    }
  }
`;

const DELETE_SCHEDULED_TRANSACTION = gql`
  mutation DeleteRepeatedScheduledTransaction($productId: ID!, $scheduleIndex: Int!) {
    deleteRepeatedScheduledTransaction(productId: $productId, scheduleIndex: $scheduleIndex) {
      ... on DafProduct {
        _id
        scheduled {
          createdAt
          endDate
          frequency
          numberOfOccurrences
          startDate
          templateTransaction
          updatedAt
        }
      }
      ... on ClatProduct {
        _id
        scheduled {
          createdAt
          endDate
          frequency
          numberOfOccurrences
          startDate
          templateTransaction
          updatedAt
        }
      }
      ... on BrandingProduct {
        _id
        scheduled {
          createdAt
          endDate
          frequency
          numberOfOccurrences
          startDate
          templateTransaction
          updatedAt
        }
      }
    }
  }
`;

export {
  ADD_SCHEDULED_TRANSACTION,
  UPDATE_SCHEDULE_TRANSACTION,
  DELETE_SCHEDULED_TRANSACTION,
};